import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import axios from "axios";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { MyApi } from "../../MyApi";
 

const Banner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(MyApi.BASE_URL + MyApi.BANNER_LIST, {
        headers: {
          Authorization: MyApi.SECRET_KEY,
        },
      })
      .then((res) => {
        if (res.data?.status) {
          setBanners(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Banner API Error:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="p-5 text-center">Loading banners...</div>;
  }

  if (!banners.length) {
    return <div className="p-5 text-center">No banners found</div>;
  }

  return (
    <div className="banner_style">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        // pagination={{ clickable: true }}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        speed={1200}
        grabCursor
        loop
        className="banner-swiper"
      >
        {banners.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="banner-slide">
              <img
                src={item.banner_url}
                alt={item.title}
                className="banner-img"
              />

              <div className="banner-text">
                <h2 className="animate-title">{item.title}</h2>
                <p className="animate-sub">{item.subtitle}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
